import * as React from "react"

function StcPayIcon(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 82 51"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}>
            <rect
                x={0.788}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                fill="#fff"
            />
            <path
                d="M50.59 30.171V20.5h1.64v.776c.498-.624 1.238-.963 2.157-.963 1.89 0 3.244 1.506 3.244 3.664 0 2.157-1.364 3.69-3.245 3.69-.927 0-1.658-.356-2.157-.98v3.485h-1.64zm1.64-7.087v1.783c.347.723.971 1.248 1.871 1.248 1.088 0 1.819-.81 1.819-2.148 0-1.32-.731-2.122-1.819-2.122-.9.01-1.524.5-1.872 1.24zM58.692 25.474c0-1.177.731-1.997 1.943-2.149l2.79-.356v-.348c0-.419-.213-.642-.606-.642h-3.503v-1.488h3.566c1.417 0 2.193.695 2.193 1.925v5.037h-1.658v-.847c-.482.677-1.275 1.06-2.3 1.06-1.444 0-2.425-.882-2.425-2.192zm2.826.855c.838 0 1.613-.472 1.899-1.167v-.874l-2.131.294c-.588.08-.918.392-.918.9 0 .544.419.847 1.15.847zM66.27 28.683h1.194c.454 0 .66-.187.81-.615l.215-.615-2.532-6.962h1.712l1.578 4.849h.035l1.507-4.85h1.685L69.7 28.488c-.374 1.096-.873 1.684-2.095 1.684H66.27v-1.488z"
                fill="#02AA7C"
            />
            <path
                d="M16.215 34.959c1.908 0 3.477-.598 4.51-1.596.776-.767 1.231-1.8 1.231-2.995 0-1.079-.401-2.05-1.141-2.79-.74-.74-1.8-1.284-3.138-1.543l-2.193-.428c-.909-.169-1.426-.624-1.426-1.256 0-.83.802-1.4 2.086-1.4.802 0 1.489.258 1.943.713.285.312.482.713.544 1.168l3.165-.713c-.09-.91-.517-1.712-1.168-2.372-1.043-1.025-2.639-1.675-4.52-1.675-1.738 0-3.191.57-4.198 1.48a4.164 4.164 0 00-1.338 3.084c0 1.052.34 1.943 1.026 2.62.686.687 1.684 1.195 2.995 1.516l2.166.517c1.088.258 1.569.66 1.569 1.373 0 .882-.802 1.4-2.113 1.4-.945 0-1.711-.313-2.193-.83a1.991 1.991 0 01-.57-1.31l-3.254.713c.09.972.544 1.827 1.23 2.514 1.079 1.132 2.826 1.81 4.787 1.81zm24.087 0c2.112 0 3.735-.767 4.849-1.855a6.34 6.34 0 001.712-2.879l-3.334-1.114a3.167 3.167 0 01-.883 1.48c-.544.517-1.284.882-2.344.882-.972 0-1.881-.374-2.54-1.025-.66-.687-1.062-1.685-1.062-2.942 0-1.284.402-2.255 1.061-2.942.65-.66 1.542-.998 2.514-.998 1.025 0 1.738.339 2.255.856.428.428.687.971.856 1.515l3.396-1.14a6.492 6.492 0 00-1.595-2.827c-1.141-1.114-2.8-1.907-4.992-1.907-2.024 0-3.851.766-5.162 2.086-1.31 1.337-2.112 3.2-2.112 5.366 0 2.166.829 4.02 2.166 5.367 1.301 1.31 3.155 2.077 5.215 2.077zm-11.526 0c1.48 0 2.54-.455 2.995-.856v-3.085c-.348.259-1.026.571-1.917.571-.633 0-1.087-.143-1.426-.455-.285-.285-.428-.775-.428-1.426v-13.06h-3.77V20.5h7.532v3.654h-7.533v6.481c0 1.31.401 2.371 1.115 3.111.802.785 1.978 1.212 3.431 1.212z"
                fill="#502C84"
            />
            <rect
                x={0.788}
                y={0.642}
                width={80.425}
                height={49.319}
                rx={5.5}
                stroke="#CECECE"
            />
        </svg>
    )
}

export default StcPayIcon
